import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";
import { CssGrid } from "styles/helpers/layout";
import { calculateRem } from "styles/mixins/calculateRem";

export const StyledProductSelectorItem = styled(CssGrid)<ThemeProps>`
  color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
  font-size: ${(props: ThemeProps) => props.theme.font.size._14};
  margin-bottom: 1.5rem;
  margin-left: 1rem;

  grid-template-columns: ${calculateRem(23)} 1fr;
  column-gap: 1rem;
  align-items: center;
  justify-items: left;

  > :first-child
  {
    align-self: center;
    justify-self: center;
  }
`;
